import { render } from "./product_codes.vue?vue&type=template&id=5ebea63c&scoped=true"
import script from "./product_codes.vue?vue&type=script&lang=js"
export * from "./product_codes.vue?vue&type=script&lang=js"

import "./product_codes.vue?vue&type=style&index=0&id=5ebea63c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ebea63c"]])

export default __exports__